<template>
  <transition name="fade">
    <div v-show="isActive" class="content-tile">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: "StoreTab",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    active: {
      type: [Boolean, String],
      default: false,
    },
  },
  data() {
    return {
      isActive: this.active,
    };
  },
  computed: {
    index() {
      return this.$parent.tabList.indexOf(this);
    },
  },
  watch: {
    "$parent.activeTabIndex"(index) {
      this.isActive = this.index === index;
    },
  },
  created() {
    this.$parent.tabList.push(this);
  },
};
</script>

<style lang="scss" scoped>
.fade-enter {
  transform: translateY(25px);
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease;
}

.fade-enter-active {
  transition-delay: 300ms;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to {
  transform: translateY(0);
}

.fade-leave-active {
  position: absolute;
  top: 0;
}

.fade-leave-to {
  transform: translateY(-50px);
}
</style>
